<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- C100系共通部品_Steps -->
    <app-c100-steps></app-c100-steps>

    <div class="information-margin"></div>

    <!-- メッセージ -->
    <div class="message">
      <!-- メッセージ本文 -->
      <div class="message-text">
        <div class="p-d-flex p-jc-center">
          <i class="pi pi-check-circle" style="font-size: 6rem"></i><br />
        </div>
        <div class="message-margin"></div>
        <div class="p-d-flex p-jc-center">
          課題・ソリューションの
          <label *ngIf="'1' == status"> 登録完了 </label>
          <label *ngIf="'0' == status"> 一時保存 </label>
        </div>
      </div>
    </div>

    <!-- 本文 -->
    <div class="p-d-flex p-jc-center">
      <label *ngIf="'1' == status">
        課題・ソリューションの登録をいたしました。<br />
        運営事務局にて承認後に一般公開となります。<br />
        一時保存の場合、運営事務局による承認は行われません。<br />
        内容について、運営事務局から直接登録ご担当者様へeメール等で確認のご連絡が行く場合がございます。
      </label>
      <label *ngIf="'0' == status">
        課題・ソリューションの登録をいたしました。<br />
        運営事務局にて承認後に一般公開となります。<br />
        一時保存の場合、運営事務局による承認は行われません。
      </label>
    </div>

    <!-- ボタンエリア -->
    <div class="p-d-flex p-jc-center button-area">
      <button
        pButton
        type="button"
        label="会員プロフィールへ戻る"
        class="button-default-size button1"
        (click)="moveB211orMoveB212()"
      ></button>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
